import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/second-place.png")